import CONTRATO_PROGRAMAS_OBRA from '@/graphql/querys/administracion/contratos/programa/contratoProgramasObra.gql';

export default {
  methods: {
    calcularDiferenciaEnDias(fechaInicio, fechaTermino) {
      const nuevaFechaInicio = new Date(`${fechaInicio}T00:00:00`);
      const nuevaFechaTermino = new Date(`${fechaTermino}T00:00:00`);
      // Calcular
      const diferenciaMiliSegundos = Math.abs(nuevaFechaTermino - nuevaFechaInicio);
      const diferenciaDias = Math.ceil(diferenciaMiliSegundos / (1000 * 60 * 60 * 24));

      return (diferenciaDias + 1);
    },
    sumarMontoAcumulado(programadoAnteriror) {
      if (!programadoAnteriror) return 0;
      return this.$ObjSumar(programadoAnteriror, 'monto');
    },
    mixCalcularPrograma(fecha) {
      const {
        porcentajeCostoIndirectos,
        porcentajeUtilidad,
        porcentajeCargosAdicionales,
      } = this.contrato;

      let total = 0;
      let indirectos = 0;
      let utilidad = 0;
      let adicionales = 0;

      if (!fecha) {
        return {
          porcentaje: 0,
          importe: 0,
          diasTranscuridos: 0,
        };
      }
      // Fecha del avance
      const alFecha = new Date(`${fecha}T00:00:00Z`);
      // Comprobar que que exista un programa de obra
      if (this.mixProgramasObras.length <= 0) return 0;

      // Seleccionar el primer programa del listado de programas de obra del contrato
      const [programaUno] = this.mixProgramasObras;

      const diasTranscuridos = this.calcularDiferenciaEnDias(
        this.mixGetPrograma[0].fechaInicio,
        fecha,
      );

      // Acumulado del programa
      const programaAcumulado = programaUno.programa
        .filter((programa) => new Date(programa.fechaTermino) < alFecha);

      // Importe acumulado
      const importeAcumulado = this.sumarMontoAcumulado(programaAcumulado);

      // Programa actual
      const programadoActual = programaUno.programa
        .filter((programa) => alFecha >= new Date(`${programa.fechaInicio}T00:00:00`)
      && alFecha < new Date(`${programa.fechaTermino}T00:00:00`));

      // Si no hay programado actual, entonces regresas el 100%
      // y, el importe acumulado actual
      if (programadoActual.length <= 0) {
        // Calcular importe programado de indirectos
        if (porcentajeCostoIndirectos > 0) {
          indirectos = this.$numberRound((importeAcumulado * (porcentajeCostoIndirectos / 100)));
        }

        // Calcular impprte programado utilidad
        if (porcentajeUtilidad > 0) {
          utilidad = ((importeAcumulado + indirectos) * (porcentajeUtilidad / 100));
        }

        // Calcular importe programado adcionales
        if (porcentajeCargosAdicionales > 0) {
          adicionales = (
            (importeAcumulado + indirectos + utilidad) * (porcentajeCargosAdicionales / 100));
        }

        total = (importeAcumulado + indirectos + utilidad + adicionales);

        const porcentajeProgramado = this.$obtenerImporteDosDecimales((
          (total / this.importeDelContrato) * 100));

        return {
          porcentaje: porcentajeProgramado > 100 ? 100 : porcentajeProgramado,
          importe: this.$obtenerImporteDosDecimales(total),
          diasTranscuridos,
        };
      }

      // Cantidad de dias ejecutados a la fecha
      const diasEjecutados = this.calcularDiferenciaEnDias(programadoActual[0].fechaInicio, fecha);

      // Cantidad de dias del periodo
      const diasDelPeriodo = this.calcularDiferenciaEnDias(
        programadoActual[0].fechaInicio,
        programadoActual[0].fechaTermino,
      );

      // Importe diario
      const importeDiario = (programadoActual[0].monto / diasDelPeriodo);

      // Importe ejecutado del periodo
      const importeEjecutadoDelPeriodo = (importeDiario * diasEjecutados);

      // Importe ejecutado
      const importeEjecutado = (importeAcumulado + importeEjecutadoDelPeriodo);

      // Calcular importe programado de indirectos
      if (porcentajeCostoIndirectos > 0) {
        indirectos = this.$numberRound((importeEjecutado * (porcentajeCostoIndirectos / 100)));
      }

      // Calcular impprte programado utilidad
      if (porcentajeUtilidad > 0) {
        utilidad = ((importeEjecutado + indirectos) * (porcentajeUtilidad / 100));
      }

      // Calcular importe programado adcionales
      if (porcentajeCargosAdicionales > 0) {
        adicionales = (
          (importeEjecutado + indirectos + utilidad) * (porcentajeCargosAdicionales / 100));
      }

      total = (importeEjecutado + indirectos + utilidad + adicionales);

      // Porcentaje de avace
      const porcentajeProgramado = ((total / this.importeDelContrato) * 100);

      // Regresar el porcentaje de avance programado y el importe ejecutado a la fecha
      return {
        porcentaje: porcentajeProgramado > 100
          ? 100
          : this.$obtenerImporteDosDecimales(porcentajeProgramado),
        importe: this.$obtenerImporteDosDecimales(total),
        diasTranscuridos,
      };
    },
  },
  apollo: {
    contratoProgramasObra: {
      query: CONTRATO_PROGRAMAS_OBRA,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  computed: {
    mixProgramasObras() {
      if (!this.contratoProgramasObra) return [];
      return this.contratoProgramasObra;
    },
    mixGetPrograma() {
      if (!this.contratoProgramasObra || this.mixProgramasObras.length <= 0) return [];
      // Destructurar el primer progama
      const [{ programa }] = this.mixProgramasObras;

      // Suma de los montos
      let suma = 0;

      return programa
        // Ordernar el programa por fecha de termino
        .sort((a, b) => new Date(`${a.fechaTermino}T00:00:00`) - new Date(`${b.fechaTermino}T00:00:00`))
        // Calcular el porcentaje de avance
        .map((item) => {
          // Sumar el monto anterior con el monto actual
          suma += item.monto;

          // Regresar el objeto con el calculo de avance
          return {
            ...item,
            // Calcular porcentaje de avance programado
            avance: this.$numberRound((suma / this.importeDelContrato) * 100),
          };
        });
    },
  },
};
